module.exports = __webpack_public_path__ + "img/logo-simplereport.d272b21e.svg";